import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function SamsungDarkSitesDialog({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[200] flex items-end sm:items-center justify-center p-4 pb-[max(1rem,env(safe-area-inset-bottom))]"
      role="dialog"
      aria-labelledby="samsung-dark-sites-title"
      aria-modal="true"
    >
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      <div className="relative z-10 mx-auto w-full max-w-md rounded-xl border border-border bg-card text-card-foreground shadow-elevated p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-lg font-semibold">
            i
          </div>
          <div className="min-w-0 flex-1 space-y-2">
            <h2 id="samsung-dark-sites-title" className="text-base font-semibold text-foreground">
              Samsung Dark Sites is on
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Your browser is forcing dark mode, so our site theme cannot switch properly right now.
              Turn off browser darkening first, then try the sun/moon button again.
            </p>
            <ol className="text-sm text-muted-foreground list-decimal pl-4 space-y-1 leading-relaxed">
              <li>Open the Samsung Internet menu (bottom right).</li>
              <li>
                Tap <strong className="text-foreground">Light sites</strong> to turn off browser
                darkening.
              </li>
              <li>Then use our sun/moon button for the site theme.</li>
            </ol>
            <button
              type="button"
              onClick={onClose}
              className="mt-2 w-full sm:w-auto rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
            >
              OK
            </button>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Dismiss"
            className="shrink-0 rounded-lg p-1.5 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            <span aria-hidden="true" className="text-lg leading-none">
              ×
            </span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
